export default "__VITE_ASSET__Dekz$_Bj__"